export const ExternalScript = {
  importScript(src) {
    // prevent same script load more than once
    if (document.querySelector(`script[src='${src}']`)) {
      return
    }
    const scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', src)
    document.head.appendChild(scriptTag)
  }
}
